import { jsx as _jsx } from "react/jsx-runtime";
/** The provider board uses the same dimensions as Diality's existing site. */
export function CareersListView({ data }) {
    if (!data.paylocityId)
        return null;
    return (_jsx("section", { id: "open-roles", "data-careers-list": true, className: "mx-auto w-full max-w-[1068px] scroll-mt-[92px]", children: _jsx("iframe", { src: `https://recruiting.paylocity.com/recruiting/jobs/All/${data.paylocityId}`, title: "Diality current openings", width: "100%", height: "1200px", "data-lenis-prevent": true, 
            // Lenis disables iframe pointer events while smoothing the parent page.
            // Keep this provider-owned board interactive throughout that animation.
            style: { display: "block", border: 0, pointerEvents: "auto" } }) }));
}
export function CareersListBlock({ data }) {
    return _jsx(CareersListView, { data: data });
}
export function careersListFromBlock(block, _resolve) {
    return { paylocityId: block.scalars?.paylocityId ?? "" };
}
export const careersListBlockEntry = {
    Component: CareersListBlock,
    fromBlock: careersListFromBlock,
};
//# sourceMappingURL=careers-list.js.map